import { render, staticRenderFns } from "./TrialQuestionSummaryTable.vue?vue&type=template&id=5e5d1163&scoped=true"
import script from "./TrialQuestionSummaryTable.vue?vue&type=script&lang=js"
export * from "./TrialQuestionSummaryTable.vue?vue&type=script&lang=js"
import style0 from "./TrialQuestionSummaryTable.vue?vue&type=style&index=0&id=5e5d1163&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5d1163",
  null
  
)

export default component.exports